import { docTypes } from '../constants/documents.constants';

export const getInitialTypeId = ({ mode, formValues, savedDraftValues }) => {
  if (mode === 'edit') {
    return formValues?.type?.id;
  }

  if (mode === 'create' && savedDraftValues?.type?.id === docTypes.outgoing) {
    return docTypes.incoming;
  }

  if (mode === 'create' && savedDraftValues?.type?.id === docTypes.incoming) {
    return docTypes.outgoing;
  }

  return null;
};
